
import React from "react";

import { useRouter } from "next/router";
import BaseLayout from "../components/layout/BaseLayout";
import PageHeader from "../components/general/PageHeader";
import LiquidityAdsTable from "../components/liquidityAdsDashboard/LiquidityAdsTable";
import WhiteContainer from "../components/layout/WhiteContainer";
import LiquidityAdSatoshiInput from "../components/liquidityAdsDashboard/LiquidityAdSatoshiInput";
import TextContainer from "../components/layout/TextContainer";
import LiquidityAdFilterbar from "../components/liquidityAdsDashboard/filters/LiquidityAdFilterbar";
import { useBtcInfo } from "../components/general/SatoshiPriceProvider";



export default function LiquidityAdsPage() {
  const [satoshi, setSatoshi] = React.useState<number>(1000 * 1000);
  const [filters, setFilters] = React.useState<Map<string, number>>(new Map());
  const btcInfo = useBtcInfo();

  return (
    <BaseLayout pageTitle="Liquidity Ad Marketplace"
    seoDescription="Get inbound liquidity at the best price possible. A decentralized marketplace for everybody." 
    shareDescription="Get inbound liquidity at the best price possible. A decentralized marketplace for everybody." disableOnMaintenance={true}>
      <PageHeader
        title="Liquidity Ad Marketplace"
        description={<div className="text-gray-600 text-lg">Get Inbound Liquidity At The Best Price Possible.<br /> A Decentralized Marketplace For Everybody.</div>}
      />

      <TextContainer className="pb-16 pt-16">
        <LiquidityAdSatoshiInput onChange={newVal => setSatoshi(newVal)} />
      </TextContainer>

      <div className="mx-auto max-w-6xl">
        <div className="mx-2 pb-2">
          <div className="flex justify-between items-end flex-wrap">
          <h2 className="text-gray-800 text-lg font-bold pl-2">Liquidity offers</h2>
          <LiquidityAdFilterbar onValueChange={(newFilter) => setFilters(newFilter)} />
          </div>
        </div>

        <WhiteContainer className="mx-2 p-2 md:p-8">
          <LiquidityAdsTable amountSat={satoshi} filters={filters} />
        </WhiteContainer>
      </div>


      <TextContainer className="py-32">
        <h2 className="text-xl font-bold mb-2 text-gray-800 ">What are Dual Funded Channels?</h2>
        <p>
          <a
            className="text-viking-800 hover:text-viking-700"
            href="https://medium.com/blockstream/c-lightning-opens-first-dual-funded-mainnet-lightning-channel-ada6b32a527c"
            target="_blank">Dual Funded Channels</a> is a technique that allows you and your peer to open a channel
          with initial funds on both sides. Up to now, a dual funded channel required manual coordination between you and your peer.

        </p>
        <h2 className="text-xl font-bold mb-2 text-gray-800 pt-12">What are Liquidity Ads?</h2>
        <p>
          Liquidity Ads are a central component to open Dual Funded Channels on demand.
          Liquidity ads solve the coordination problem by allowing your node to advertise its willingness
          to contribute funds to a channel open request from a peer directly over the Lightning gossip network.
          This means that every node on the Lightning Network can broadcast their intention to contribute funds to a channel,
          as well as see all the nodes that are currently offering up liquidity directly, without any added services or software.
        </p>

        <h2 className="text-xl font-bold mb-2 text-gray-800 pt-12">How do I set up liquidity ads?</h2>
        <p>
          Checkout 
          this <a
            className="text-viking-800 hover:text-viking-700"
            href="https://medium.com/blockstream/setting-up-liquidity-ads-in-c-lightning-54e4c59c091d"
            target="_blank">blog by Lisa Neigut</a> on how to setup liquidity ads in c-lightning. More implementations will come in the future.
        </p>


        <h2 className="text-xl font-bold mb-2 text-gray-800 pt-12">How is the channel open fee calculated?</h2>
        <p>Then channel open fee is based on</p>
        <ul className="pl-4 list-disc py-2">
          <li>The advertised leasing costs</li>
          <li>Onchain funding size (vbytes)</li>
          <li>Current onchain fee</li>
        </ul>

        <h3 className=" font-bold mb-2 text-gray-800 pt-4">Formula</h3>
        <p className="">
          Open fee = <span className="code bg-white">Demanded Satoshi</span> * <span className="code bg-white">Lease Proportional Fee</span> + <span className="code bg-white">Lease Base Fee</span> + <span className="code bg-white">Onchain Funding Size</span> * <span className="code bg-white">Onchain Fees</span>
        </p>

        <h2 className="text-xl font-bold mb-2 text-gray-800 pt-12">Help. Funding the channel failed.</h2>
        <p>
          LnRouter doesn't know how much funds a node has available to contribute to a dual funded channel.
          Therefore, even though LnRouter lists a node, it is not guarantueed that the demanded liquidity is available.
          </p>

        <h2 className="text-xl font-bold mb-2 text-gray-800 pt-12">What are the current onchain fee rates?</h2>
        <WhiteContainer className="inline-block px-4 py-2">
          <table>
            <tbody>
              <tr>
                <td className="pr-4 text-sm">
                  Low
                </td>
                <td>
                  {btcInfo?.transactionFeesSatPerVByte?.low} sat/vbyte
                </td>
              </tr>
              <tr>
                <td className="pr-4 text-sm">
                  Medium
                </td>
                <td>
                  {btcInfo?.transactionFeesSatPerVByte?.medium} sat/vbyte
                </td>
              </tr>
              <tr>
                <td className="pr-4 text-sm">
                  High
                </td>
                <td>
                  {btcInfo?.transactionFeesSatPerVByte?.high} sat/vbyte
                </td>
              </tr>
            </tbody>
          </table>
        </WhiteContainer>
        <p className="text-sm text-gray-500">
          *Source: <a className="text-viking-800 hover:text-viking-700" target="_blank"
            href="https://mempool.space">mempool.space</a>
        </p>


      </TextContainer>

    </BaseLayout>
  );
}
